import { computed } from 'vue'
import VueFeather from 'vue-feather'

export const BuefyFeather = (props: { icon: string[] | undefined }) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, iconType] = props.icon ? props.icon : ['feather', 'feather']
  const computedIconType = computed(() => {
    if (iconType === 'close-circle') {
      return 'x-circle'
    }
    return iconType
  })
  return <VueFeather type={computedIconType.value} />
}
